import CategoryLink from './components/CategoryLink';
import ContentSection from './components/ContentSection';
import FaqItems from './components/FaqItems';
import PageHeader from './components/PageHeader';
import { SocialProofSection } from './components/social-proof-section';
import StickyUseTemplateDesktop from './components/StickyUseTemplateDesktop';
import StickyUseTemplateMobile from './components/StickyUseTemplateMobile';
export default {
  CategoryLink: CategoryLink,
  ContentSection: ContentSection,
  PageHeader: PageHeader,
  StickyUseTemplateDesktop: StickyUseTemplateDesktop,
  StickyUseTemplateMobile: StickyUseTemplateMobile,
  FaqItems: FaqItems,
  SocialProofSection: SocialProofSection
};